import React from 'react';
import moment from 'moment';
import { apiPost } from '../../../../services/apiClient';
import { print } from '../../../../services/print';
import ConfirmModal from '../../../../modals/confirmModal.jsx';
import InformationModal from '../../../../modals/infoModal.jsx';
import FileSelectionModal from '../../../../modals/fileSelectionModal.jsx';
import DocumentCommentCell from './controls/docCommentCell.jsx'
import DocumentTypeCell from './controls/docTypeCell.jsx'

export default class DocumentsTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0
        };
		
        this.confirmModal = null;
        this.infoModal = null;
        this.fileSelectionModal = null;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

	removeDocument(document) {
		let title = "Удаление документа из посылки";
		this.confirmModal.open(title, "Вы действительно хотите удалить документ '" + document.fileName + "'?")
			.then(() => {
				this.updateBusyCount(1);
				apiPost("parcels/documents/" + this.props.parcel.id + "/file/" + document.id + "/delete")
					.then(() => {
						this.updateBusyCount(-1);
						this.props.reload();
					})
					.catch(err => {
						this.updateBusyCount(-1);
						if (err.message) {
							this.infoModal.open(title, err.message);
						}
					});
			})
			.catch(() => { });
	}

	printDocument(document) {
		let fileUrl = this.getDownloadUrl(document);
		print({
			url: fileUrl, 
			contentType: document.contentType
		});
	}

	uploadNewFile() {
		let title = 'Загрузка документа в посылку';
		this.fileSelectionModal.open(title)
			.then(file => {
				let data = new FormData();
				data.append('file', file);
				this.updateBusyCount(1);
				apiPost("parcels/documents/" + this.props.parcel.id + "/upload", data)
					.then(() => {
						this.updateBusyCount(-1);
                        this.props.reload();
					})
					.catch(err => {
						this.updateBusyCount(-1);
						if (err.message) {
							this.infoModal.open(title, err.message);
						}
					});
			})
			.catch(() => {});
	}

	getDownloadUrl(document) {
		let fileUrl = getApiBaseUrl() + "parcels/documents/file/" + document.key + "/download";
		return fileUrl;
	}

	renderUploadButton(isBusy) {
		if (this.props.parcel.statusCode === "Completed") {
			return null;
		} else {
			return (
				<div className="box-header no-vert-padding">
					<button className="btn btn-flat btn-default btn-sm btn-tool" 
						onClick={() => this.uploadNewFile()}
						disabled={isBusy}
					>
						<span className="fa fa-upload"></span> Добавить
					</button>
				</div>
			);
		}
	}

	renderRemoveButton(document, isBusy) {
		if (document.isEditable) {
			return (
				<a role="button" className="float-right icon-right-tool" 
					onClick={() => this.removeDocument(document)}
					disabled={isBusy}
				>
					<span className="fa fa-trash text-red"></span>
				</a>
			);
		} else {
			return null;
		}
	}

	renderPrintButton(document, isBusy) {
		return (
			<a role="button" className="float-right icon-right-tool" 
				onClick={() => this.printDocument(document)}
				disabled={isBusy}
			>
				<span className="glyphicon glyphicon-print"></span>
			</a>
		);
	}

	renderTableRow(document, isBusy) {
		let rowKey = "doc-" + document.id;
		let fileUrl = this.getDownloadUrl(document);
		let createdAt = moment(document.createdAt).format('DD.MM.YYYY hh:mm');
		return (
			<tr key={rowKey}>
				<td>
					<a href={fileUrl} disabled={isBusy}>{document.fileName}</a>
					{this.renderRemoveButton(document, isBusy)}
					{this.renderPrintButton(document, isBusy)}
				</td>
				<DocumentTypeCell parcelId={this.props.parcel.id}
					documentId={document.id}
					value={document.documentType}
					items={document.allDocumentTypes ? document.allDocumentTypes.entries : []}
					isEditable={document.isTypeEditable}
				/>
				<DocumentCommentCell parcelId={this.props.parcel.id}
					documentId={document.id}
					value={document.comment}
					isEditable={document.isEditable}
				/>
				<td>{document.userName}</td>
				<td>{createdAt}</td>
			</tr>
		);
	}

	renderTable(isBusy) {
		let rows = null;
		if (this.props.documents) {
			rows = this.props.documents.map((document, ind, array) => this.renderTableRow(document, isBusy));
		}
		return (
            <div className="box-body table-responsive">
                <table className="table table-bordered table-hover static-grid">
                    <thead>
                        <tr>
							<th>Наименование файла</th>
							<th>Тип документа</th>
							<th>Комментарий</th>
							<th>Автор</th>
							<th>Дата создания</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
		);
	}

    render() {
		let isBusy = this.props.isBusy || this.state.busyCount > 0;
        return (
            <div>
				{this.renderUploadButton(isBusy)}
				{this.renderTable(isBusy)}
				
                <ConfirmModal ref={modal => this.confirmModal = modal} />
                <InformationModal ref={modal => this.infoModal = modal} />
                <FileSelectionModal ref={modal => this.fileSelectionModal = modal} />
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/documentsTab.jsx